module.exports = __webpack_public_path__ + "static/img/regina1.9bfa3eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/regina1.jpg
// module id = 126
// module chunks = 9